import React, { useContext, useEffect, useState } from "react";
import "./Product_Details.css";
import Product_Image from "./product_image/Product_Image";
import Common_Back_Btn from "../common_components/common_back_btn/Common_Back_Btn";
import Product_Description from "./product_description/Product_Description";
import Perfect_Partner from "./perfect_partner/Perfect_Partner";
import { useParams } from "react-router-dom";
import {
  getProductDetail,
  Products,
} from "../../utils/luxuryapis/Product/Product";
import { Context } from "../../utils/context";
import { decodeId } from "../../utils/common";

const Product_Details = () => {
  const { id } = useParams();
  const [product, setproduct] = useState();
  const [variant, setVariant] = useState(null);
  const [subVariant, setSubVariant] = useState(null);
  const deid = decodeId(id);
  const getAllData = async (id) => {
    let res = await getProductDetail(id);
    if (res?.success) {
      setproduct(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  useEffect(() => {
    getAllData(deid);
  }, [deid]);
  const { IMG_URL } = useContext(Context);
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    if (product?.product_variants && product?.product_variants?.length > 0) {
      setVariant(product?.product_variants[0]);
    }
  }, [product]);
  useEffect(() => {
    if (variant && variant?.product_images.length > 0) {
      setSelectedImage(IMG_URL + variant?.product_images[0]?.image);
    }
    if (variant && variant?.product_quantities.length > 0) {
      setSubVariant(variant?.product_quantities?.[0]);
    }
  }, [variant]);

  return (
    <section className="Product_Details">
      <div className="custom_container">
        <Common_Back_Btn backText="Back" />

        <div className="row">
          <div className="col-xl-8">
            <div className="left_side">
              <Product_Image
                product={product}
                variant={variant}
                setSelectedImage={setSelectedImage}
                selectedImage={selectedImage}
              />

              <div className="hidden_product_descn">
                <Product_Description
                  setSubVariant={setSubVariant}
                  subVariant={subVariant}
                  setSelectedImage={setSelectedImage}
                  product={product}
                  setVariant={setVariant}
                  variant={variant}
                />
              </div>
            </div>
          </div>
          <div className="col-xl-4">
            <div className="right_side">
              <Product_Description
                setSubVariant={setSubVariant}
                subVariant={subVariant}
                setSelectedImage={setSelectedImage}
                product={product}
                setVariant={setVariant}
                variant={variant}
              />
            </div>
          </div>
        </div>

        <Perfect_Partner />
      </div>
    </section>
  );
};

export default Product_Details;
